import 'jquery-touchswipe';

// handle hover for touch devices in css
if (!("ontouchstart" in document.documentElement)) {
  document.documentElement.className += " no-touch";
} else {
  document.documentElement.className += " touch";
}

require('./modules/main');
require('./tools/utils');
require('./seo/usercentrics');

require('./helper/conditionalScripts');
require('./libs/jquery.cookie');
require('./plugins/immomanagement/backToSelection');
require('./plugins/immomanagement/openImmoSearch');
require('./plugins/immomanagement/openImmoSearchFilter');
require('./fce/formOverlay');
require('./plugins/ondigoform');
require('./helper/adjustBoxHeight');
require('./helper/clickableBox');
require('./helper/formEnhancement');
require('./fce/videoJs/youtube');
require('./fce/videoJs/videojsCustom');
require('./fce/numberPicker');
require('./fce/iframeLoader');
require('./fce/lightbox');
require('./fce/rearrangeableContent');
require('./fce/simpleFilter');
require('./fce/slider');
require('./fce/tabNavigation');
require('./fce/teaserSlider');
require('./fce/toggler');
require('./fce/filter');
require('./fce/referenceHandler');
require('./fce/fadeToggler');
require('./fce/tabSlider');
require('./fce/immomanagement/sliderLightbox');
require('./fce/immomanagement/googleEmbed');
require('./page/secondLevelMobile');
require('./page/slideInNavigation');
require('./page/provenExpertWidget');
require('./page/scrollToTop');